import type {
  ContentObject,
  WithOptionalInternalProps,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type FormAfterSubmitEventInit = {
  /** If the form submission was successful */
  success: boolean;
  /**
   * New content object data returned from API.
   * If the form submission fails, the data will return the values
   * with which the submission was triggered.
   */
  contentObject: WithOptionalInternalProps<ContentObject> | null;
  /** Errors returned after submitting the form. */
  errors?: object | null;
};

/**
 * An event that is fired when an object form is submitted (after the API call is triggered).
 * It will be skipped if client side validation fails.
 * No result is expected.
 *
 * @eventName "flotiq.form::after-submit"
 * @memberof FlotiqPlugins.Events
 */
export class FormAfterSubmitEvent extends IFlotiqPluginEvent {
  constructor(initData: FormAfterSubmitEventInit) {
    super(initData);
  }
}
